import React, { Component, PropTypes } from 'react';
import { envValue } from '../../../config/envUtils';

const FRONTMAN_URL = envValue('FRONTMAN_URL');

class IframePreview extends Component {
    constructor(props) {
        super(props);
        this.iframe = null;
        this.iframeBody = null;
    }

    componentDidMount() {
        try {
            this.iframeDocument = this.iframe.contentDocument;
            this.iframeBody = this.iframeDocument.body;
        } catch (e) {
            console.log(e);
        }
    }

    _setStyle() {
        const { iframeContentStyle } = this.props;

        Object.assign(this.iframeDocument.getElementsByClassName('app_appLevelStyles')[0].style, iframeContentStyle);
    }

    renderFrameContents() {
        if (this.iframeDocument.readyState === 'complete') {
            this._setStyle();
        } else {
            setTimeout(this.renderFrameContents, 0);
        }
    }

    render() {
        const { url, windowHeight, windowWidth } = this.props;

        return (
            <iframe
                title="Booking Engine Designer"
                ref={node => {
                    this.iframe = node;
                }}
                id="be-designer-help"
                height={windowHeight}
                width={windowWidth}
                src={url}
            />
        );
    }
}

IframePreview.propTypes = {
    url: PropTypes.string.isRequired,
    windowHeight: PropTypes.string.isRequired,
    windowWidth: PropTypes.string.isRequired,
    iframeContentStyle: PropTypes.object.isRequired
};

export default IframePreview;



// WEBPACK FOOTER //
// ./src/components/pages/IFramePreview.js